import { render, staticRenderFns } from "./BaseInputFile.vue?vue&type=template&id=d4049bd6&scoped=true&"
import script from "./BaseInputFile.vue?vue&type=script&lang=js&"
export * from "./BaseInputFile.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputFile.vue?vue&type=style&index=0&id=d4049bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4049bd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4049bd6')) {
      api.createRecord('d4049bd6', component.options)
    } else {
      api.reload('d4049bd6', component.options)
    }
    module.hot.accept("./BaseInputFile.vue?vue&type=template&id=d4049bd6&scoped=true&", function () {
      api.rerender('d4049bd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseInputFile.vue"
export default component.exports